<template ref="addList">
	<div class="zujian">
		<!-- 所属分类 -->
		<div class="belong-wrap">
			<span class="">所属分类：</span>
			<Select v-model="cateId" style="width:200px">
				<Option v-for="item in cateList" :value="item.cate_id" :key="item.cate_id">{{ item.content }}</Option>
			</Select>
		</div>
		<!-- 商品列表 -->
		<div class="" style="padding-bottom: 10px;">添加内容：</div>
		<div class="components-goods-list">
			<div class="components-goods-item" v-for="(item,index) in dataList" :key="index">
				<img :src="$publicData.ossUrl+item.thumb">
				<div class="icon-wrap">
					<Icon type="md-expand" size="20" @click="onShowItemImage(1,item,index)" />
					<Icon type="md-close-circle" size="20" style="margin-left:10px;" @click="delFun(index)"/>
				</div>
			</div>
			<div class="components-zhanwei" @click="onShowItemImage(0)">
				<Icon type="md-add" size="40" />
			</div>
		</div>
		<div class="drawer-footer">
			<Button style="margin-right: 8px" @click="cancleFun">取消</Button>
			<Button type="primary" @click="activityAdd">确定</Button>
		</div>
		<!-- 单个组件 -->
		<Modal
			v-model="showItemImageModal"
			:footer-hide="true"
			:mask-closable="false"
			title="添加">
			<add-item-image ref="addItemImage" @showItemImage="onShowItemImage($event)" @updateList="onUpdateList"></add-item-image>
		</Modal>
	</div>
</template>
<script>
import UploadThumb from "../../common/thumb";
import addItemImage from "./addListThumb.vue";
export default {
	name: "",
	data(){
		return {
			dataList: [],
			showItemImageModal: false,
			cateId: -1,
			cateList: [],
			zhuanti_id: null,
			type_id: null, // 4竖排 5横排
			block_content_id: null // 模块内容id
		}
	},
	// 计算
	computed: {},
	// 监听
	watch: {},
	components: {
		UploadThumb,
		addItemImage
	},
	created: function(){
		
	},
	methods: {
		// 初始化
		initFun(status,type,zhuanti_id,block_content_id){
			this.dataList = [];
			this.cateId = null;
			this.type_id = type;
			this.zhuanti_id = zhuanti_id;
			this.block_content_id = block_content_id;
			this.getCateList(zhuanti_id);
			if(status == 1){
				this.detailFun(block_content_id);
			}
		},
		// 分类列表
		getCateList(zhuanti_id){
			this.$api.zhuanti.catelist({zhuanti_id: zhuanti_id}).then(res=>{
				if(res.code == 200){
					let list = res.result; // 二维数组(可能有多个大分类)
					let arr = [];
					arr.push({
						cate_id: -1,
						content: "无"
					})
					if(list && list.length){
						for(let i in list){
							let item = list[i];
							for(let j in item){
								if(item[j].content && item[j].content.length > 12){
									item[j].content = item[j].content.slice(0,12)+'...'
								}
								arr.push(item[j]);
							}
						}
					}
					this.cateList = arr;
				}else{
					this.$Message.error(res.msg)
				}
			})
		},
		
		// 单个删除
		delFun(index){
			this.dataList.splice(index,1);
		},
		// 详情
		detailFun(id){
			console.log("详情",id)
			let params = {
				block_content_id: id
			};
			this.$api.zhuanti.blockdetail(params).then(res=>{
				if(res.code == 200){
					if(res.result.parent_id){
						this.cateId = res.result.parent_id;
					};
					if(res.result.content){
						let content = JSON.parse(res.result.content);
						this.dataList = content;
					}
				}else{
					this.$Message.error(res.msg)
				}
			})
		},
		// 取消
		cancleFun(){
			this.$emit("showList", -1);
		},
		// 确定
		activityAdd(){
			console.log("cateId",this.cateId)
			if(this.dataList.length == 0){
				this.$Message.warning("内容为空！");
				return;
			};
			let content = this.dataList;
			if(this.block_content_id){
				// 编辑
				let params = {
					block_content_id: this.block_content_id,
					content: JSON.stringify(content)
				};
				if(this.cateId && this.cateId != -1){
					params.cate_id = this.cateId;
				}
				this.$api.zhuanti.blockedit(params).then(res=>{
					if(res.code == 200){
						this.$emit("updateContent");
					}else{
						this.$Message.error(res.msg)
					}
				})
			}else{
				// 新增
				if(this.cateId && this.cateId != -1){
					// 有所属分类
					let params = {
						cate_id: this.cateId,
						type_id: this.type_id, // 4竖排 5横排
						content: JSON.stringify(content)
					};
					this.$api.zhuanti.blockcatecontent(params).then(res=>{
						if(res.code == 200){
							this.$emit("updateContent");
						}else{
							this.$Message.error(res.msg)
						}
					})
				}else{
					// 无所属分类
					let params = {
						zhuanti_id: this.zhuanti_id,
						content: JSON.stringify(content),
						type_id: this.type_id // 4竖排 5横排
					}
					this.$api.zhuanti.blockcreate(params).then(res=>{
						if(res.code == 200){
							this.$emit("updateContent");
						}else{
							this.$Message.error(res.msg)
						}
					})
				}
			}
			
		},
		// 单个商品
		onShowItemImage(status,item,index){
			this.currentIndex = null;
			// 0新增 1编辑
			if(status == 0){
				this.showItemImageModal = true;
				this.$refs.addItemImage.initFun()
			}else if(status == 1){
				this.showItemImageModal = true;
				this.currentIndex = index;
				this.$refs.addItemImage.detailFun(item);
			}else if(status == -1){
				this.showItemImageModal = false;
			}
		},
		// 更新商品列表
		onUpdateList(status,params){
			if(status){
				// 编辑
				this.dataList[this.currentIndex] = params;
			}else{
				// 新增
				this.dataList.push(params);
			}
			this.showItemImageModal = false;
			console.log("商品列表",this.dataList)
		}
	}
}
</script>
<style>
	.zujian img{
		max-width: 100%;
		display: block;
	}
	.components-goods-list{
		display: flex;
		flex-wrap: wrap;
	}
	.components-goods-item{
		width: 100px;
		height: 100px;
		overflow: hidden;
		margin-left: 10px;
		margin-bottom: 10px;
		position: relative;
		border: 1px dashed #000000;
	}
	.components-goods-item .icon-wrap{
		background: rgba(255,255,255,1);
		position: absolute;
		top: 10px;
		right: 10px;
	}
	.components-zhanwei{
		width: 100px;
		height: 100px;
		margin-left: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px dashed #000000;
	}
	.belong-wrap{
		margin-bottom: 20px;
	}
</style>